import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iconoRef'
})
export class IconoRefPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return '#'+value;
  }

}
